import React from 'react';

const Features: React.FC = () => {
  const features = [
    {
      title: "Mood-Based Quote Matching",
      description: "Choose how you're feeling, and we'll surface quotes to match your vibe.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: "from-yellow-600/30 to-yellow-900/30",
      iconColor: "text-yellow-400"
    },
    {
      title: "Favorites & Collections",
      description: "Save quotes that hit home and organize them into your own personal collections.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
        </svg>
      ),
      color: "from-orange-600/30 to-orange-900/30",
      iconColor: "text-orange-400"
    },
    {
      title: "Create Your Own Quotes",
      description: "Feeling inspired? Write your own quotes and save them for later.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      ),
      color: "from-purple-800/30 to-purple-950/30",
      iconColor: "text-purple-400"
    },
    {
      title: "Explore by Category",
      description: "Browse quotes across themes that matter to you, from self-discovery to leadership.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      ),
      color: "from-green-800/30 to-green-950/30",
      iconColor: "text-green-400"
    }
  ];

  return (
    <div className="py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-white text-2xl md:text-3xl font-bold text-center mb-10 drop-shadow-md">
          Features You'll Love
        </h2>
        
        <div className="grid grid-cols-2 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={`bg-gradient-to-b ${feature.color} border border-gray-800 rounded-2xl p-5 text-white hover:scale-105 transition-transform duration-300`}
            >
              <div className="flex flex-col items-center text-center h-full">
                <div className={`mb-4 ${feature.iconColor}`}>{feature.icon}</div>
                <h3 className="text-lg md:text-xl font-bold mb-2">{feature.title}</h3>
                <p className="opacity-80 text-sm md:text-base">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features; 